import axios from 'axios';

const RESSOURCE_NAME = 'documents';

export default {
    uploadDocument(id, data, config) {
        // var personnes = Object.fromEntries(data.personnes)
        return axios.post(`${RESSOURCE_NAME}/upload/` + id, data, config)
    },

    uploadProjectDocuments(id_entreprise, id_projet, data) {
        return axios.post(`${RESSOURCE_NAME}/projet/${id_entreprise}/${id_projet}`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        })
    },

    deleteEntrepriseDocument(id_entreprise, data) {
        return axios.post(`${RESSOURCE_NAME}/entreprise/${id_entreprise}/delete`, { chemin: data.chemin });
    },

    deleteProjectDocument(id_entreprise, id_projet, data) {
        return axios.post(`${RESSOURCE_NAME}/projet/${id_entreprise}/${id_projet}/delete`, { chemin: data.chemin });
    },

    createDirectory(data) {
        return axios.post(`${RESSOURCE_NAME}/entreprise/${data.entreprise}/directory`, { subpath: data.path });
    },

    uploadFile(data, id, config) {
        return axios.post(`${RESSOURCE_NAME}/entreprise/` + id, data, config);
    },
    downloadFile(url) {
        return axios.get(url, { responseType: 'arraybuffer' })
    },
    getProjectDocuments(project_id) {
        return axios.get(`${RESSOURCE_NAME}/projet/${project_id}`);
    },
    deleteDirectory(id, data) {
        return axios.post(`${RESSOURCE_NAME}/entreprise/${id}/directory/delete`, { subpath: data.path });
    },
};
